import { FOOTER_IDS } from '../../constants/footerIds/footer-ids.constant'
import { FOOTER_CONFIG } from '../../constants/footerConfig/footer-config.constant'

/**
 * @file Defines the {@link FooterManager} class.
 * @author <joe.thompson@1x2network.com>
 */

 /** Class handling footer */
 export class FooterManager {

    /**
     * Field for storing current balance
     * @memberof FooterManager
     * @protected
     * @instance
     * @type {string}
     */
    _balance

    /**
     * Field for storing current time
     * @memberof FooterManager
     * @protected
     * @instance
     * @type {string}
     */
    _clock
    
    /**
     * Field for storing game messages
     * @memberof FooterManager
     * @protected
     * @instance
     * @type {string}
     */
    _message

    /**
     * Field for storing win messages
     * @memberof FooterManager
     * @protected
     * @instance
     * @type {string}
     */
    _win

    /**
     * Initialize footer for new UI
     */
    constructor() {

        //Create div for footer
        let footer = document.createElement('footer')
        footer.id  = 'footer'

        //Loop through footer halfs
        for (let half in FOOTER_CONFIG) {

            //Create div for each footer half
            let halfDiv = document.createElement('div')
            halfDiv.id = `footer-${half}`

            //If Gambling Commission logo being displayed
            if (window.GamblingCommission && window.GamblingCommission.use) {

                halfDiv.classList.add('gamblingCommission')                     //Adjust footer styling
                half === 'bottom' && window.GamblingCommission.render(halfDiv)  //Render Gambling Commission logo

            }

            //Loop through sections in footer half
            for (let i = 0; i < FOOTER_CONFIG[half].length; i++) {

                let s = FOOTER_CONFIG[half][i] //Store footer section

                //Create span for footer section
                let span = document.createElement('span')
                span.id  = `footer-${half}-${s.id}`

                //If footer has custom styling for specific language
                if (s.custom) {

                    //If custom styling config exists for language used
                    if (s.custom[gameParams.lang]) {
                        
                        //If desktop
                        if (!framework.isTouch()) {
                            span.style.width   = `${s.custom[gameParams.lang].width.desktop}%`
                        }

                        //Mobile
                        else {
                            span.style.width   = `${s.custom[gameParams.lang].width.mobile}%`
                        }

                    }

                }

                //If footer section has sibling sections
                if (s.siblings) {

                    //Loop through sections
                    for (let j = 0; j < s.siblings.length; j++) {

                        let sibling   = s.siblings[j]                          //Store sibling
                        let childSpan = document.createElement('span')         //Create span for sibling
                        childSpan.id  = `footer-${half}-${s.id}-${sibling.id}` //Set ID
                        span.appendChild(childSpan)                            //Add to footer section

                    }

                }

                halfDiv.appendChild(span) //Add footer section to footer half

            }

            footer.appendChild(halfDiv) //Add footer half to footer

        }

        //Add footer
        framework.isTouch() ? document.getElementById('buttonWrapper').appendChild(footer) : document.getElementById('gameFramework').appendChild(footer)
        
        document.getElementById('footer-bottom-balance-text').innerHTML = Translate.do('Balance:') //Translate footer balance text

        //BRAN-16 HOTFIX Store chracter length of clock for branded megaways
        var clockLength = gameParams.gameName.length + gameParams.clientName.length

        //BRAN-16 HOTFIX if branded megaways and client name and game name character greater than 20
        if (gameParams.gameName.includes('Branded') && gameParams.clientName !== "null" && clockLength > 20) {
            document.getElementById(FOOTER_IDS['clock']).classList.add('branded')   //Add styling to increase clock width on landscape
        }

    }

    /** Get balance */ get balance() { return this._balance }

    /** Set balance */ 
    set balance(v_) {

        this._balance = v_

        document.getElementById(FOOTER_IDS['balance']).innerHTML = this._balance //Update in UI

     }

     /** Get clock */ get clock() { return this._clock }

     /** Set clock */ 
    set clock(v_) {

        this._clock = v_ 

        document.getElementById(FOOTER_IDS['clock']).innerHTML = this._clock //Update in UI

    }

    /** Get message */ get message() { return this._message }

    /** Set message */ 
    set message(v_) {

        this._message = v_ 

        document.getElementById(FOOTER_IDS['message']).innerHTML = this._message //Update in UI

    }

    /** Get win */ get win() { return this._win }

    /** Set win */
    set win(v_) {

        this._win = v_

        document.getElementById(FOOTER_IDS['win']).innerHTML = this._win //Update in UI

    }

 }